import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import TestPages from "../views/TestPages.vue";
import store from "@/store";
Vue.use(VueRouter);

var routes = [
  {
    path: "/Login",
    component: () =>
      import(
        /* webpackChunkName: "Login" */ `../views/Login.vue`
      ),
    name: "Login",
    meta: {
      guest: true
    }
  },  
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
        requiresAuth: true
    }
  },
  {
    path: "/Report",
    component: () =>
      import(
        /* webpackChunkName: "Report" */ `../views/Report.vue`
      ),
    name: "Report",
    meta: {
        requiresAuth: true
    }
  },
  {
    path: "/Test-pages",
    component: TestPages,
    name: "TestPages",
    meta: {
        requiresAuth: true
    }
  },
  {
    path: "/DefaultTemplate",
    component: () =>
      import(
        /* webpackChunkName: "WithoutFooter" */ `../views/pass/DefaultTemplate.vue`
      ),
    name: "DefaultTemplate"
  },
  {
    path: "/DefaultInfoServiceTemplate",
    component: () =>
      import(
        /* webpackChunkName: "WithoutFooter" */ `../views/pass/DefaultInfoServiceTemplate.vue`
      ),
    name: "DefaultInfoServiceTemplate"
  },
  {
    path: "/DefaultInfoServiceNoGlobalNav",
    component: () =>
      import(
        /* webpackChunkName: "DefaultInfoServiceNoGlobalNav" */ `../views/fail/DefaultInfoServiceNoGlobalNav.vue`
      ),
    name: "DefaultInfoServiceNoGlobalNav"
  },
  {
    path: "/WithInfoServiceImageNavigation",
    component: () =>
      import(
        /* webpackChunkName: "WithoutFooter" */ `../views/pass/WithInfoServiceImageNavigation.vue`
      ),
    name: "WithInfoServiceImageNavigation"
  },
  {
    path: "/WithInfoServiceImageNavigationFail",
    component: () =>
      import(
        /* webpackChunkName: "WithoutFooter" */ `../views/fail/WithInfoServiceImageNavigationFail.vue`
      ),
    name: "WithInfoServiceImageNavigationFail"
  },
  {
    path: "/WithoutFooter",
    component: () =>
      import(
        /* webpackChunkName: "WithoutFooter" */ `../views/fail/WithoutFooter.vue`
      ),
    name: "WithoutFooter"
  },
  {
    path: "/WithoutHeader",
    component: () =>
      import(
        /* webpackChunkName: "WithoutHeader" */ `../views/fail/WithoutHeader.vue`
      ),
    name: "WithoutHeader"
  },
  {
    path: "/SingleStepForm",
    component: () =>
      import(
        /* webpackChunkName: "SingleStepForm" */ `../views/pass/SingleStepForm.vue`
      ),
    name: "SingleStepForm"
  },
  {
    path: "/FormWithNoSections",
    component: () =>
      import(
        /* webpackChunkName: "FormWithNoSections" */ `../views/fail/FormWithNoSections.vue`
      ),
    name: "FormWithNoSections"
  },
  {
    path: "/SingleStep6Sections",
    component: () =>
      import(
        /* webpackChunkName: "SingleStep6Sections" */ `../views/fail/SingleStep6Sections.vue`
      ),
    name: "SingleStep6Sections"
  },
  {
    path: "/MultiStepForm",
    component: () =>
      import(
        /* webpackChunkName: "MultiStepForm" */ `../views/pass/MultiStepForm.vue`
      ),
    name: "MultiStepForm"
  },
  {
    path: "/MultiStepForm7Steps",
    component: () =>
      import(
        /* webpackChunkName: "MultiStepForm7Steps" */ `../views/fail/MultiStepForm7Steps.vue`
      ),
    name: "MultiStepForm7Steps"
  },
  {
    path: "/NotUsingTemplate",
    component: () =>
      import(
        /* webpackChunkName: "NotUsingTemplate" */ `../views/fail/NotUsingTemplate.vue`
      ),
    name: "NotUsingTemplate"
  },
  {
    path: "/MultiStepFormNoIndicator",
    component: () =>
      import(
        /* webpackChunkName: "MultiStepFormNoIndicator" */ `../views/fail/MultiStepFormNoIndicator.vue`
      ),
    name: "MultiStepFormNoIndicator"
  },
  {
    path: "/ImageWithAlt",
    component: () =>
      import(
        /* webpackChunkName: "ImageWithAlt" */ `../views/pass/ImageWithAlt.vue`
      ),
    name: "ImageWithAlt"
  },
  {
    path: "/ImageWithoutAlt",
    component: () =>
      import(
        /* webpackChunkName: "ImageWithoutAlt" */ `../views/fail/ImageWithoutAlt.vue`
      ),
    name: "ImageWithoutAlt"
  },
  {
    path: "/ImageWithAltInfo",
    component: () =>
      import(
        /* webpackChunkName: "ImageWithAltInfo" */ `../views/pass/ImageWithAltInfo.vue`
      ),
    name: "ImageWithAltInfo"
  },
  {
    path: "/ImageWrongFormatInfo",
    component: () =>
      import(
        /* webpackChunkName: "ImageWrongFormatInfo" */ `../views/fail/ImageWrongFormatInfo.vue`
      ),
    name: "ImageWrongFormatInfo"
  },
  {
    path: "/ImageWithoutAltInfo",
    component: () =>
      import(
        /* webpackChunkName: "ImageWithoutAltInfo" */ `../views/fail/ImageWithoutAltInfo.vue`
      ),
    name: "ImageWithoutAltInfo"
  },
  {
    path: "/SorryPage",
    component: () =>
      import(
        /* webpackChunkName: "SorryPage" */ `../views/pass/SorryPage.vue`
      ),
    name: "SorryPage"
  },
  {
    path: "/UsingIframe",
    component: () =>
      import(
        /* webpackChunkName: "UsingIframe" */ `../views/fail/UsingIframe.vue`
      ),
    name: "UsingIframe"
  },
  {
    path: "/WithoutBreadcrumb",
    component: () =>
      import(
        /* webpackChunkName: "WithoutBreadcrumb" */ `../views/fail/WithoutBreadcrumb.vue`
      ),
    name: "WithoutBreadcrumb"
  },
  {
    path: "/SummaryPage",
    component: () =>
      import(
        /* webpackChunkName: "SummaryPage" */ `../views/pass/SummaryPage.vue`
      ),
    name: "SummaryPage"
  },
  {
    path: "/WithoutSaveButton",
    component: () =>
      import(
        /* webpackChunkName: "WithoutSaveButton" */ `../views/fail/WithoutSaveButton.vue`
      ),
    name: "WithoutSaveButton"
  },
  {
    path: "/AcknowledgementPage",
    component: () =>
      import(
        /* webpackChunkName: "AcknowledgementPage" */ `../views/pass/AcknowledgementPage.vue`
      ),
    name: "AcknowledgementPage"
  },
  {
    path: "/AcknowledgementPageNoFields",
    component: () =>
      import(
        /* webpackChunkName: "AcknowledgementPageNoFields" */ `../views/fail/AcknowledgementPageNoFields.vue`
      ),
    name: "AcknowledgementPageNoFields"
  },
  {
    path: "/WithoutProfile",
    component: () =>
      import(
        /* webpackChunkName: "WithoutProfile" */ `../views/fail/WithoutProfile.vue`
      ),
    name: "WithoutProfile" 
  },
  {
    path: "/WithImageNavigation",
    component: () =>
      import(
        /* webpackChunkName: "WithImageNavigation" */ `../views/fail/WithImageNavigation.vue`
      ),
    name: "WithImageNavigation" 
  },
  {
    path: "/ListOfeServices",
    component: () =>
      import(
        /* webpackChunkName: "ListOfeServices" */ `../views/pass/ListOfeServices.vue`
      ),
    name: "ListOfeServices" 
  },
  {
    path: "/ListOfeServicesWithNoServices",
    component: () =>
      import(
        /* webpackChunkName: "ListOfeServicesWithNoServices" */ `../views/fail/ListOfeServicesWithNoServices.vue`
      ),
    name: "ListOfeServicesWithNoServices" 
  },
  {
    path: "/ServiceLandingPage",
    component: () =>
      import(
        /* webpackChunkName: "ServiceLandingPage" */ `../views/pass/ServiceLandingPage.vue`
      ),
    name: "ServiceLandingPage" 
  },
  {
    path: "/GlobalMenuPage",
    component: () =>
      import(
        /* webpackChunkName: "GlobalMenuPage" */ `../views/pass/GlobalMenuPage.vue`
      ),
    name: "GlobalMenuPage" 
  },
  {
    path: "/LandingPage",
    component: () =>
      import(
        /* webpackChunkName: "LandingPage" */ `../views/pass/LandingPage.vue`
      ),
    name: "LandingPage" 
  },
  {
    path: "/LandingPageWithoutTimeStamp",
    component: () =>
      import(
        /* webpackChunkName: "LandingPageWithoutTimeStamp" */ `../views/fail/LandingPageWithoutTimeStamp.vue`
      ),
    name: "LandingPageWithoutTimeStamp" 
  },
  {
    path: "/LandingPageWithoutFooter",
    component: () =>
      import(
        /* webpackChunkName: "LandingPageWithoutFooter" */ `../views/fail/LandingPageWithoutFooter.vue`
      ),
    name: "LandingPageWithoutFooter" 
  },
  {
    path: "/LandingPageWithoutArticles",
    component: () =>
      import(
        /* webpackChunkName: "LandingPageWithoutArticles" */ `../views/fail/LandingPageWithoutArticles.vue`
      ),
    name: "LandingPageWithoutArticles" 
  },
  {
    path: "/SiteMapPage",
    component: () =>
      import(
        /* webpackChunkName: "SiteMapPage" */ `../views/pass/SiteMapPage.vue`
      ),
    name: "SiteMapPage" 
  },
  {
    path: "/ServiceLandingPageNoTable",
    component: () => 
    import(
      /* webpackChunkName: "ServiceLandingPageNoTable" */ `../views/fail/ServiceLandingPageNoTable.vue`
    ),
  name: "ServiceLandingPageNoTable"
  }
];

const router = new VueRouter({
    routes,
    scrollBehavior() {
      document.getElementById("app").scrollIntoView();
      return null;
    },
  });
  router.beforeEach((to, from, next) => {
    if(to.matched.some(record => record.meta.requiresAuth)) {
      if (!store.state.auth.status.loggedIn) {
          next({
              path: 'Login',
              params: { nextUrl: to.fullPath }
          })
      } else {
          let user = store.state.auth.user;
          if(to.matched.some(record => record.meta.is_admin)) {
              if(user.is_admin == 1){
                  next()
              }
              else{
                  next({ name: 'Login'})
              }
          }else {
              next()
          }
      }
    }else {
        next()
    }
  });

  export default router;